import { IconName } from '@components/utils/icons/icon';

import { NetworkWithOrWithoutConfig } from '../types';
import { getNetworkName } from './network';

export const getIconName = (network: NetworkWithOrWithoutConfig): IconName => {
    return getNetworkName(network) as IconName;
};
